<lib-form-field-container
    [kind]="FormContainerKind.Text"
    [isOptional]="isOptional">
    <ng-content
        label
        select="[label]"></ng-content>
    <ng-content
        supportingText
        select="[supportingText]"></ng-content>
    <ng-content
        prefixText
        select="[prefixText]">
        @if (!percentSymbolRightPlacement) {
            {{ percentSymbol }}
        }
    </ng-content>
    <ng-content
        suffixText
        select="[suffixText]">
        @if (percentSymbolRightPlacement) {
            {{ percentSymbol }}
        }
    </ng-content>
    <ng-container readOnly>
        <div
            #providedReadOnly
            class="wrapper-content">
            <ng-content select="[readOnly]"></ng-content>
        </div>
        <div class="default-content">
            <ng-container>{{ formControl.value ? (formControl.value | formatPercent: minDecimalPlaces : maxDecimalPlaces) : 'Not specified' }}</ng-container>
        </div>
    </ng-container>

    <input
        [id]="formFieldID"
            [attr.aria-describedby]="formFieldID + '-description ' + formFieldID + '-error'"
                        [attr.aria-label]="ariaLabel || null"
                        [attr.aria-invalid]="formControl.isDirty && formControl.errors ? 'true' : null"
            [attr.aria-required]="formControl.isRequired"
        [formControl]="viewControl"
        [placeholder]="placeholderText"
        autocomplete="nope"
        inputmode="decimal"
        (blur)="OnBlur()"
        (focus)="OnFocus()"
        (change)="$event.stopPropagation()"
        [attr.data-sb-qa]="qaTag" />
</lib-form-field-container>
